var evaluateHidePostVideo = function (_a) {
    var showVideo = _a.showVideo, videoUrl = _a.videoUrl;
    if (!showVideo || !videoUrl)
        return true;
};

export { evaluateHidePostVideo };
//# sourceMappingURL=evaluateHidePostVideo.js.map
